//
// AttributesModel.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../GTLModel";

var AttributesModel = createModule("gtl::AttributesModel", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        copyFromBundle: [0,1],
        setStyleElement: [0,4],
        setStyleElementChain: [0,[4]],
    },
    ,
    ,
]);
export default AttributesModel;
